// extracted by mini-css-extract-plugin
export default {"landscapeDocumentsWrapper":"LandscapeDocumentsTemplate_landscapeDocumentsWrapper__qudKD"};